import React, { useState } from "react";
import StarAttendees from "../../../../components/attendanceAppreciation/StarAttendees";
import DayPermission from "../../../../components/dayPermission/DayPermission";
import AttendanceHome from "./AttendanceHome";
import AttendancePermission from "./AttendancePermission";


const SwitchAttendance = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <AttendanceHome />
          </div>
        );

      case 2:
        return (
          <div>
            <AttendancePermission />
          </div>
        );

      case 3:
        return (
          <div>
            <DayPermission mode="approver" classesUrl="/teachers/classes" />
          </div>
        );

      case 4:
        return (
          <div>
            <StarAttendees classesUrl="/teachers/classes" />
          </div>
        );

      default:
        return (
          <div>
            <AttendanceHome />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Home</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">View Permissions</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Day Permission</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${
              step === 4 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Star Attendees</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchAttendance;
